module.exports = __webpack_public_path__ + "static/media/industries-pharma-s.d3e448b9.webp";